import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e331c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assign-trustcontact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "Assign Authorised Trust Contact")
], -1))
const _hoisted_3 = { class: "body-main" }
const _hoisted_4 = { class: "ls-form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Law Practice:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Address:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Assign Authorised Trust Contact", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }),
  /*#__PURE__*/_createTextVNode(" Invalid LawID or Email ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-info-circle",
    style: {"font-size":"20px","color":"var(--ls-slate)"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Once you have set up the trust contact with a LawID please enter the email address of the Authorised Trust Contact to delegate access to this branch with immediate effect.")
], -1))
const _hoisted_11 = { class: "controls mt-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      halfScreen: "true",
      onClose: _cache[3] || (_cache[3] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("fieldset", null, [
              _hoisted_5,
              _createElementVNode("div", null, _toDisplayString(this.practice?.practice?.practiceName), 1),
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(this.practice?.practice?.address), 1),
              _hoisted_7,
              _createElementVNode("div", {
                class: _normalizeClass(['input-box', _ctx.trustContact === '' || _ctx.errorWithContact ? 'error': ''])
              }, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.trustContact) = $event)),
                  placeholder: "Enter Email",
                  maxlength: "109",
                  minLength: "10"
                }, null, 512), [
                  [_vModelText, _ctx.trustContact]
                ]),
                _hoisted_9
              ], 2),
              _hoisted_10
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline",
            disabled: _ctx.submitting,
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Back ", 8, _hoisted_12),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.assignContact()), ["prevent","stop"]))
          }, " Submit ", 8, _hoisted_13)
        ])
      ]),
      _: 1
    })
  ]))
}